import React, { useState, useEffect } from "react";
import styles from "@/views/login/Login.module.less";
import { Form, Input, Button, message } from "antd";
import { Link } from "react-router-dom";
import { managerLogin, logout, googleV3Record, getConfigInfo } from "@/services/request";
import { IInjectIntlProps, Intl } from "@/model/index";
import { useLocation } from "react-router-dom";
import LoginLayoutSAS from "./components/LoginLayoutSAS";
import {
  PASSWORD_MAX_LENGTH,
  MD5_FIXED_STRING,
  RECAPTCHA_V2_KEY_INVISIBLE,
  USER_ROLE_POWER
} from "@/config/constants";
import WithFiatAndSpotTrade from "@/components/withFiatAndSpotTrade/WithFiatAndSpotTrade";
import md5 from "md5";
// import { grecaptchaToken } from "@/utils/index";
// import ReCAPTCHA from "react-google-recaptcha";
import Bugsnag from "@bugsnag/js";

interface IProps extends IInjectIntlProps {
  unregisterWS: () => void;
  handleBlur: (event: { target: { value: any }; currentTarget: any }) => void;
  handleFocus: (event: { target: { value: any }; currentTarget: any }) => void;
}
let ManagerLogin: React.FC<IProps> = (props: IProps) => {
  const state = useLocation()?.state;
  const intl: Intl = window.__intl__.messages;
  const [accountName, setAccountName] = useState<string>(state?.email);
  const [password, setPassword] = useState<string>(state?.password);
  const [loading, setLoading] = useState<boolean>(false);
  const [showRecaptcha, setShowRecaptcha] = useState<boolean>(false);
  const emailInput = React.useRef<any>(null);
  const [form] = Form.useForm();
  // const recaptchaRef = React.createRef<any>();

  useEffect(() => {
    emailInput?.current?.focus();
  }, [accountName]);

  useEffect(() => {
    const error = localStorage.getItem("error");
    if (error) {
      message.destroy();
      message.error(intl[error]);
    }
    props.unregisterWS();
    window.ws = null;
    emailInput?.current?.focus();
    form.setFieldsValue({ email: accountName, password });
    logout()
      .then()
      .finally(() => {
        localStorage.clear();
        getConfigInfo().then((res) => {
          if (res?.code == 0) {
            setShowRecaptcha(res.data?.isRecaptcha);
          }
        });
      });
  }, []);

  const handleSubmit: () => void = async () => {
    // if (showRecaptcha) {
    //   try {
    //     recaptchaRef?.current?.execute();
    //   } catch (e) {
    //     message.destroy();
    //     message.error(intl["login.network.error"]);
    //     Bugsnag.notify(new Error("[ws.send(/api/alive)] -- [error]: " + "recaptcha loaded error"));
    //   }
    // } else {
    // fetchSubmit();
    // }
    fetchSubmit();
  };
  const fetchSubmit = async (recaptchaValue2?: string) => {
    setLoading(true);
    //const clientTokenV3 = await grecaptchaToken();
    const params = {
      account: accountName,
      clientToken: showRecaptcha ? recaptchaValue2 : null,
      password: md5(password + MD5_FIXED_STRING)
    };
    //googleV3Record({ clientToken: clientTokenV3 });

    managerLogin(params)
      .then(async (res) => {
        if (res?.code == "0") {
          const {
            user_id,
            account_id,
            jwtToken,
            idCertifiedStatus,
            isGoogleCertified,
            user_roles,
            customer_info
          } = res?.data;
          let auditStatus: string = "";
          // "idCertifiedStatus 认证审核状态：0未认证，1待审核，2已通过, 3已拒绝, 只有管理端审核了状态才会变更
          // kyc接口： 0 Auditing 审核中，1 Certified  通过，2 Rejected  拒绝
          if (idCertifiedStatus == 0) {
            auditStatus = "";
          }
          if (idCertifiedStatus == 1) {
            auditStatus = "0";
          }
          if (idCertifiedStatus == 2) {
            auditStatus = "1";
          }
          if (idCertifiedStatus == 3) {
            auditStatus = "2";
          }
          localStorage.setItem(
            "user_auth",
            user_roles ? user_roles.join(",").toLocaleLowerCase() : ""
          );
          localStorage.setItem(`${location.origin}jwtToken`, jwtToken ?? "");
          localStorage.setItem("isAuthenticated", "true");
          localStorage.setItem("user", accountName);
          localStorage.setItem("customerId", account_id ?? user_id);
          localStorage.setItem("customerInfo", customer_info);
          localStorage.setItem("kycCertifiedStatus", auditStatus);
          localStorage.setItem("isGoogleCertified", Number(isGoogleCertified).toString());
          window.location.href = "/clients";
        } else {
          /*错误判断包含：
           * 1. 账号未注册，服务器端判断返回
           * 2. 账号或者密码错误，服务器端判断返回
           * 3. 密码错误超过5次，锁定2小时
           */
          setLoading(false);
          message.destroy();
          message.error(intl[res?.msg] ?? res?.msg);
        }
      })
      .finally(() => {
        // window.grecaptcha.reset();
        setLoading(false);
      });
  };
  const title: string = intl["login.text.SAS"];
  const messageEmail: string = intl["register.email.incorrect"];

  return (
    <div className={styles.formSAS}>
      <div className={styles.container}>
        <p className={styles.title}> {title} </p>
        <Form
          name="basic"
          layout="vertical"
          autoComplete="off"
          form={form}
          initialValues={{ accountName: accountName, password: password }}
          onFinish={handleSubmit}>
          {/* 为了解决chrome浏览器自动填充input不触发onchange问题 */}
          <Input type="password" autoComplete="new-password" className="hiddenInput" />
          <Form.Item
            className={styles.email}
            name="email"
            validateTrigger="onBlur"
            rules={[
              {
                type: "email",
                message: messageEmail
              },
              {
                required: true,
                message: messageEmail
              }
            ]}>
            <div>
              <label className={styles.label + " " + (accountName ? styles.active : "")}>
                {intl["login.email"]}
              </label>
              <Input
                className={accountName ? styles.inputHover : ""}
                autoComplete="new-password"
                autoFocus={true}
                ref={emailInput}
                name="accountName"
                value={accountName}
                onChange={(e) => setAccountName(e.target.value)}
                onFocus={(e) => {
                  form.setFields([
                    {
                      name: "email",
                      value: e.target.value,
                      errors: null
                    }
                  ]);
                  props.handleFocus(e);
                }}
                onBlur={props.handleBlur}
              />
            </div>
          </Form.Item>
          <Form.Item rules={[{ required: true, message: intl["error.password.format"] }]}>
            <div>
              <label className={styles.label + " " + (password ? styles.active : "")}>
                {intl["login.password"]}
              </label>
              <Input
                className={password ? styles.inputHover : ""}
                name="password"
                type="password"
                maxLength={PASSWORD_MAX_LENGTH}
                defaultValue={password}
                onChange={(e) => setPassword(e.target.value)}
                onFocus={props.handleFocus}
                onBlur={props.handleBlur}
              />
            </div>
          </Form.Item>
          <Button
            className={styles.submit}
            type="primary"
            htmlType="submit"
            disabled={accountName && password ? false : true}
            loading={loading}>
            {intl["login"]}
          </Button>
          {/* <ReCAPTCHA
            ref={recaptchaRef}
            size="invisible"
            hl="en"
            theme="dark"
            sitekey={RECAPTCHA_V2_KEY_INVISIBLE}
            onChange={(value) => {
              fetchSubmit(value);
            }}
          /> */}
        </Form>
      </div>
    </div>
  );
};
export default LoginLayoutSAS(WithFiatAndSpotTrade(ManagerLogin));
